<div>
  @if (!hideIdentificationClass) { @if (displayIdentificationAsSelect) {
  <nz-form-item>
    @if (isCurrencyCloudPaymentsControls) {
    <nz-form-label translate>payment.receiverInfo.identification.title</nz-form-label>
    } @if (label) {
    <nz-form-label translate>{{label}}</nz-form-label>
    }
    <nz-form-control>
      <nz-select
        nzSize="large"
        nzShowSearch
        l10n-placeholder
        [nzPlaceHolder]="placeholder"
        [formControl]="identificationClassControl"
        [attr.data-cy]="controlDataCy(identificationClassControl)"
      >
        <nz-option [nzValue]="null"></nz-option>
        @for (identificationClass of (allowedClasses && allowedClasses.length ? allowedClasses : PaymentIdentificationClasses); track identificationClass) {
        <nz-option [nzValue]="identificationClass" [nzLabel]="'payment.identification.classifier.' + identificationClass | translate: locale.language">
        </nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  } @else {
  <nz-form-control>
    <nz-radio-group [formControl]="identificationClassControl" [attr.data-cy]="controlDataCy(identificationClassControl)">
      @for (identificationClass of PaymentIdentificationClasses; track identificationClass) {
      <label nz-radio [nzValue]="identificationClass"> {{ 'payment.identification.classifier.' + identificationClass | translate: locale.language}} </label>
      }
    </nz-radio-group>
  </nz-form-control>
  } } @if (showNameControl && nameControl?.enabled) {
  <nz-form-item>
    <nz-form-label>{{nameControlLabelKey | translate: locale.language}} </nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [placeholder]="nameControlLabelKey | translate: locale.language"
        [formControl]="nameControl"
        [maxlength]="nameMaxLength"
        [attr.data-cy]="controlDataCy(nameControl)"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (surnameControl?.enabled) {
  <nz-form-item>
    <nz-form-label translate>reg.details.personSurname.label</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [placeholder]="'reg.details.personSurname.label' | translate: locale.language"
        [formControl]="surnameControl"
        [maxlength]="nameMaxLength"
        [attr.data-cy]="controlDataCy(surnameControl)"
      />
    </nz-form-control>
  </nz-form-item>
  } @if (identificationClass && identificationTypeControl) { @if (!isCurrencyCloudPaymentsControls) {
  <nz-form-item>
    <nz-form-label translate>payment.identification.type.label</nz-form-label>
    <nz-form-control>
      <nz-radio-group [formControl]="identificationTypeControl" [attr.data-cy]="controlDataCy(identificationTypeControl)">
        @for (identificationType of PaymentIdentificationTypes(); track identificationType) {
        <label nz-radio [nzValue]="identificationType"> {{ 'payment.identification.classifier.' + identificationType | translate: locale.language}} </label>
        }
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>
  } @switch (identificationType) { @case (PaymentIdentificationType.OTHER) { @if (isControlVisible(identificationCodeTypeControl)) {
  <nz-form-item>
    <nz-form-label translate>payment.identification.type.label</nz-form-label>
    <nz-form-control>
      <nz-select
        nzSize="large"
        nzShowSearch
        [nzPlaceHolder]="'payment.identification.type.selectPlaceholder' | translate: locale.language"
        [formControl]="identificationCodeTypeControl"
        [attr.data-cy]="controlDataCy(identificationCodeTypeControl)"
      >
        @for (identificationTypeCode of paymentIdentificationTypeCodes$() | async; track identificationTypeCode) {
        <nz-option [nzValue]="identificationTypeCode.id" [nzLabel]="identificationTypeCode.label"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  } @if (!hideOtherTypeIdControl && isControlVisible(idControl)) {
  <nz-form-item>
    <nz-form-label translate>payment.identification.id.label</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [placeholder]="'payment.identification.id.placeholder' | translate: locale.language"
        [formControl]="idControl"
        [attr.data-cy]="controlDataCy(idControl)"
      />
    </nz-form-control>
  </nz-form-item>
  } } @case (PaymentIdentificationType.BIC_BEI) {
  <nz-form-item>
    <nz-form-label translate>payment.identification.id.label</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        [placeholder]="'payment.identification.id.placeholder' | translate: locale.language"
        [formControl]="idControl"
        [attr.data-cy]="controlDataCy(idControl)"
      />
    </nz-form-control>
  </nz-form-item>
  } @case (PaymentIdentificationType.DATE_PLACE_OF_BIRTH) {
  <nz-form-item>
    <nz-form-label translate>payment.identification.birthDate.label</nz-form-label>
    <nz-form-control>
      <nz-date-picker
        nzSize="large"
        [nzShowToday]="false"
        [nzAllowClear]="false"
        [nzDisabledDate]="birthDateDisabled"
        [nzPlaceHolder]="'payment.identification.birthDate.placeholder' | translate: locale.language"
        l10n-placeholder
        [formControl]="birthDateControl"
        [attr.data-cy]="controlDataCy(birthDateControl)"
      ></nz-date-picker>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label translate>payment.identification.countryOfBirth.label</nz-form-label>
    <nz-form-control>
      <nz-select
        nzSize="large"
        nzShowSearch
        l10n-placeholder
        [nzPlaceHolder]="'payment.identification.countryOfBirth.placeholder' | translate: locale.language"
        [formControl]="countryOfBirthControl"
        [attr.data-cy]="controlDataCy(countryOfBirthControl)"
      >
        @for (country of countries$ | async; track country.id) {
        <nz-option [nzLabel]="country.label" [nzValue]="country.id"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label translate>payment.identification.provinceOfBirth.label</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        l10n-placeholder
        [placeholder]="'payment.identification.provinceOfBirth.placeholder' | translate: locale.language"
        [formControl]="provinceOfBirthControl"
        [attr.data-cy]="controlDataCy(provinceOfBirthControl)"
      />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label translate>payment.identification.cityOfBirth.label</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        nzSize="large"
        type="text"
        l10n-placeholder
        [placeholder]="'payment.identification.cityOfBirth.placeholder' | translate: locale.language"
        [formControl]="cityOfBirthControl"
        [attr.data-cy]="controlDataCy(cityOfBirthControl)"
      />
    </nz-form-control>
  </nz-form-item>
  } } }
</div>
